module.exports = __webpack_public_path__ + "img/季卫东.a6d58e86.jpg";